import React from 'react';
import { useSettingsAccess } from './useSettingsAccess';

interface SettingsAccessControlProps {
  children: React.ReactNode;
  allowedRoles?: 'systemAdmin' | 'creditViewer' | 'both';
}

/**
 * Access control wrapper for settings pages
 *
 * @param allowedRoles - Who can access this page:
 *   - 'systemAdmin': Only system admins (default for most settings)
 *   - 'creditViewer': System admins OR users with CREDIT_VIEWER role
 *   - 'both': Both system admins and credit viewers (same as creditViewer)
 */

export const SettingsAccessControl: React.FC<SettingsAccessControlProps> = ({ children, allowedRoles = 'systemAdmin' }) => {
  const { hasAccess, isLoading } = useSettingsAccess(allowedRoles);

  // Show nothing while loading or if no access
  if (isLoading || !hasAccess) {
    return null;
  }

  return <>{children}</>;
};
